webpackJsonp([21,168,238,239,240,241,242,298],{

/***/ 106:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ([{
    props: [{
        name: '<code>type</code>',
        description: 'Type (color) of the control, optional',
        type: 'String',
        values: '<code>is-white</code>, <code>is-black</code>, <code>is-light</code>,\n                    <code>is-dark</code>, <code>is-primary</code>, <code>is-info</code>, <code>is-success</code>,\n                    <code>is-warning</code>, <code>is-danger</code>,\n                    and any other colors you\'ve set in the <code>$colors</code> list on Sass',
        default: '—'
    }, {
        name: '<code>size</code>',
        description: 'Vertical size of button, optional',
        type: 'String',
        values: '<code>is-small</code>, <code>is-medium</code>, <code>is-large</code>',
        default: '—'
    }, {
        name: '<code>loading</code>',
        description: 'Add the loading state to the button',
        type: 'Boolean',
        values: '—',
        default: '<code>false</code>'
    }, {
        name: '<code>rounded</code>',
        description: 'Rounded style',
        type: 'Boolean',
        values: '—',
        default: '<code>false</code>'
    }, {
        name: '<code>outlined</code>',
        description: 'Outlined style',
        type: 'Boolean',
        values: '—',
        default: '<code>false</code>'
    }, {
        name: '<code>expanded</code>',
        description: 'Button will be expanded (full-width)',
        type: 'Boolean',
        values: '—',
        default: '<code>false</code>'
    }, {
        name: '<code>icon-left</code>',
        description: 'Icon name to show on the left',
        type: 'String',
        values: '—',
        default: '—'
    }, {
        name: '<code>icon-right</code>',
        description: 'Icon name to show on the right',
        type: 'String',
        values: '—',
        default: '—'
    }, {
        name: '<code>icon-pack</code>',
        description: 'Icon pack to use',
        type: 'String',
        values: '<code>mdi</code>, <code>fa</code>, <code>fas</code>, <code>far</code>, <code>fad</code>, <code>fal</code>',
        default: '<code>mdi</code>'
    }, {
        name: '<code>native-type</code>',
        description: 'Button type, like native',
        type: 'String',
        values: 'Any native button type',
        default: '<code>button</code>'
    }, {
        name: '<code>tag</code>',
        description: 'Button tag name',
        type: 'String',
        values: '<code>button</code>, <code>a</code>, <code>input</code>, <code>router-link</code>, <code>nuxt-link</code> or other nuxt alias',
        default: '<code>button</code>'
    }, {
        name: 'Any native attribute',
        description: '—',
        type: '—',
        values: '—',
        default: '—'
    }],
    events: [{
        name: '<code>click</code>',
        description: 'Triggers on click',
        parameters: '<code>event: $event</code>'
    }, {
        name: '<code>[any].native</code>',
        description: 'Listen to any event using this syntax, e.g <code>mousedown.native</code>',
        parameters: '<code>event: $event</code>'
    }]
}]);

/***/ }),

/***/ 107:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(971),
  /* template */
  __webpack_require__(972),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 108:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  null,
  /* template */
  __webpack_require__(973),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 109:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  null,
  /* template */
  __webpack_require__(974),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 110:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  null,
  /* template */
  __webpack_require__(975),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 111:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  null,
  /* template */
  __webpack_require__(976),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 112:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  null,
  /* template */
  __webpack_require__(977),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1318:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api_button__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__examples_ExSimple__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__examples_ExSimple___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__examples_ExSimple__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__raw_loader_examples_ExSimple__ = __webpack_require__(1319);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__raw_loader_examples_ExSimple___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__raw_loader_examples_ExSimple__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__examples_ExTypesStates__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__examples_ExTypesStates___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__examples_ExTypesStates__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__raw_loader_examples_ExTypesStates__ = __webpack_require__(1320);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__raw_loader_examples_ExTypesStates___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__raw_loader_examples_ExTypesStates__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__examples_ExIcons__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__examples_ExIcons___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__examples_ExIcons__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__raw_loader_examples_ExIcons__ = __webpack_require__(1321);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__raw_loader_examples_ExIcons___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__raw_loader_examples_ExIcons__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__examples_ExSizes__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__examples_ExSizes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__examples_ExSizes__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__raw_loader_examples_ExSizes__ = __webpack_require__(1322);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__raw_loader_examples_ExSizes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__raw_loader_examples_ExSizes__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__examples_ExTags__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__examples_ExTags___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__examples_ExTags__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__raw_loader_examples_ExTags__ = __webpack_require__(1323);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__raw_loader_examples_ExTags___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__raw_loader_examples_ExTags__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__examples_ExRouter__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__examples_ExRouter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__examples_ExRouter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__raw_loader_examples_ExRouter__ = __webpack_require__(1324);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__raw_loader_examples_ExRouter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__raw_loader_examples_ExRouter__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





















/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            api: __WEBPACK_IMPORTED_MODULE_0__api_button__["default"],
            ExSimple: __WEBPACK_IMPORTED_MODULE_1__examples_ExSimple___default.a,
            ExTypesStates: __WEBPACK_IMPORTED_MODULE_3__examples_ExTypesStates___default.a,
            ExIcons: __WEBPACK_IMPORTED_MODULE_5__examples_ExIcons___default.a,
            ExSizes: __WEBPACK_IMPORTED_MODULE_7__examples_ExSizes___default.a,
            ExTags: __WEBPACK_IMPORTED_MODULE_9__examples_ExTags___default.a,
            ExRouter: __WEBPACK_IMPORTED_MODULE_11__examples_ExRouter___default.a,
            ExSimpleCode: __WEBPACK_IMPORTED_MODULE_2__raw_loader_examples_ExSimple___default.a,
            ExTypesStatesCode: __WEBPACK_IMPORTED_MODULE_4__raw_loader_examples_ExTypesStates___default.a,
            ExIconsCode: __WEBPACK_IMPORTED_MODULE_6__raw_loader_examples_ExIcons___default.a,
            ExSizesCode: __WEBPACK_IMPORTED_MODULE_8__raw_loader_examples_ExSizes___default.a,
            ExTagsCode: __WEBPACK_IMPORTED_MODULE_10__raw_loader_examples_ExTags___default.a,
            ExRouterCode: __WEBPACK_IMPORTED_MODULE_12__raw_loader_examples_ExRouter___default.a
        };
    }
});

/***/ }),

/***/ 1319:
/***/ (function(module, exports) {

module.exports = "<template>\n    <section>\n        <b-button @click=\"clickMe\">Click Me</b-button>\n    </section>\n</template>\n\n<script>\n    export default {\n        methods: {\n            clickMe() {\n                this.$buefy.notification.open('Clicked!!')\n            }\n        }\n    }\n</script>\n"

/***/ }),

/***/ 1320:
/***/ (function(module, exports) {

module.exports = "<template>\n    <section>\n\n        <div class=\"buttons\">\n            <b-button type=\"is-primary\">Primary</b-button>\n\n            <b-button type=\"is-success\">Success</b-button>\n\n            <b-button type=\"is-danger\">Danger</b-button>\n\n            <b-button type=\"is-warning\">Warning</b-button>\n\n            <b-button type=\"is-info\">Info</b-button>\n\n            <b-button type=\"is-link\">Link</b-button>\n\n            <b-button type=\"is-light\">Light</b-button>\n\n            <b-button type=\"is-dark\">Dark</b-button>\n\n            <b-button type=\"is-text\">Text</b-button>\n        </div>\n\n        <div class=\"buttons\">\n            <b-button disabled>Disabled</b-button>\n\n            <b-button loading>Loading</b-button>\n\n            <b-button rounded>Rounded</b-button>\n        </div>\n\n        <div class=\"buttons\">\n            <b-button type=\"is-primary\" outlined>Outlined</b-button>\n            <b-button type=\"is-success\" outlined>Outlined</b-button>\n            <b-button type=\"is-danger\" outlined>Outlined</b-button>\n            <b-button type=\"is-warning\" outlined>Outlined</b-button>\n        </div>\n\n        <div class=\"buttons\">\n            <b-button type=\"is-primary\" expanded>Expanded</b-button>\n        </div>\n\n        <div class=\"notification is-primary\">\n            <b-button type=\"is-primary\"\n                inverted>\n                Inverted\n            </b-button>\n\n            <b-button type=\"is-primary\"\n                inverted\n                outlined>\n                Invert Outlined\n            </b-button>\n        </div>\n\n    </section>\n</template>\n"

/***/ }),

/***/ 1321:
/***/ (function(module, exports) {

module.exports = "<template>\n    <section>\n        <div class=\"buttons\">\n            <b-button size=\"is-small\"\n                icon-left=\"github-circle\">\n                Add\n            </b-button>\n\n            <b-button icon-left=\"github-circle\">\n                Add\n            </b-button>\n\n            <b-button size=\"is-medium\"\n                icon-left=\"github-circle\">\n                Add\n            </b-button>\n\n            <b-button size=\"is-large\"\n                icon-left=\"github-circle\">\n                Add\n            </b-button>\n        </div>\n\n        <div class=\"buttons\">\n            <b-button type=\"is-danger\"\n                icon-left=\"delete\">\n                Delete\n            </b-button>\n\n            <b-button type=\"is-danger\"\n                icon-right=\"delete\">\n                Delete\n            </b-button>\n\n            <b-button type=\"is-danger\"\n                icon-right=\"delete\" />\n        </div>\n\n    </section>\n</template>\n"

/***/ }),

/***/ 1322:
/***/ (function(module, exports) {

module.exports = "<template>\n    <section>\n        <div class=\"buttons\">\n            <b-button size=\"is-small\">Small</b-button>\n            <b-button>Default</b-button>\n            <b-button size=\"is-medium\">Medium</b-button>\n            <b-button size=\"is-large\">Large</b-button>\n        </div>\n    </section>\n</template>\n"

/***/ }),

/***/ 1323:
/***/ (function(module, exports) {

module.exports = "<template>\n    <section>\n        <div class=\"buttons\">\n            <b-button>Button</b-button>\n\n            <b-button tag=\"a\"\n                href=\"https://buefy.org\"\n                target=\"_blank\">\n                Anchor\n            </b-button>\n\n            <b-button tag=\"input\"\n                native-type=\"submit\"\n                value=\"Submit input\" />\n        </div>\n    </section>\n</template>\n"

/***/ }),

/***/ 1324:
/***/ (function(module, exports) {

module.exports = "<template>\n    <section>\n        <div class=\"buttons\">\n            <b-button tag=\"router-link\"\n                to=\"/documentation\"\n                type=\"is-link\">\n                Docs\n            </b-button>\n            <b-button tag=\"router-link\"\n                to=\"/expo\"\n                type=\"is-info\">\n                Expo\n            </b-button>\n        </div>\n    </section>\n</template>\n"

/***/ }),

/***/ 1325:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('Example', {
    attrs: {
      "component": _vm.ExSimple,
      "code": _vm.ExSimpleCode,
      "vertical": ""
    }
  }), _vm._v(" "), _c('Example', {
    attrs: {
      "component": _vm.ExTypesStates,
      "code": _vm.ExTypesStatesCode,
      "title": "Types and states",
      "vertical": ""
    }
  }), _vm._v(" "), _c('Example', {
    attrs: {
      "component": _vm.ExSizes,
      "code": _vm.ExSizesCode,
      "title": "Sizes",
      "vertical": ""
    }
  }), _vm._v(" "), _c('Example', {
    attrs: {
      "component": _vm.ExIcons,
      "code": _vm.ExIconsCode,
      "title": "Icons",
      "vertical": ""
    }
  }), _vm._v(" "), _c('Example', {
    attrs: {
      "component": _vm.ExTags,
      "code": _vm.ExTagsCode,
      "title": "Tags",
      "vertical": ""
    }
  }), _vm._v(" "), _c('Example', {
    attrs: {
      "component": _vm.ExRouter,
      "code": _vm.ExRouterCode,
      "title": "Router",
      "vertical": ""
    }
  }, [_c('div', {
    staticClass: "tags has-addons"
  }, [_c('span', {
    staticClass: "tag is-success"
  }, [_vm._v("New!")]), _vm._v(" "), _c('span', {
    staticClass: "tag is-info"
  }, [_vm._v("0.7.6")])])]), _vm._v(" "), _c('ApiView', {
    attrs: {
      "data": _vm.api
    }
  })], 1)
},staticRenderFns: []}

/***/ }),

/***/ 358:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1318),
  /* template */
  __webpack_require__(1325),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 971:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
    methods: {
        clickMe: function clickMe() {
            this.$buefy.notification.open('Clicked!!');
        }
    }
});

/***/ }),

/***/ 972:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('b-button', {
    on: {
      "click": _vm.clickMe
    }
  }, [_vm._v("Click Me")])], 1)
},staticRenderFns: []}

/***/ }),

/***/ 973:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('div', {
    staticClass: "buttons"
  }, [_c('b-button', {
    attrs: {
      "type": "is-primary"
    }
  }, [_vm._v("Primary")]), _vm._v(" "), _c('b-button', {
    attrs: {
      "type": "is-success"
    }
  }, [_vm._v("Success")]), _vm._v(" "), _c('b-button', {
    attrs: {
      "type": "is-danger"
    }
  }, [_vm._v("Danger")]), _vm._v(" "), _c('b-button', {
    attrs: {
      "type": "is-warning"
    }
  }, [_vm._v("Warning")]), _vm._v(" "), _c('b-button', {
    attrs: {
      "type": "is-info"
    }
  }, [_vm._v("Info")]), _vm._v(" "), _c('b-button', {
    attrs: {
      "type": "is-link"
    }
  }, [_vm._v("Link")]), _vm._v(" "), _c('b-button', {
    attrs: {
      "type": "is-light"
    }
  }, [_vm._v("Light")]), _vm._v(" "), _c('b-button', {
    attrs: {
      "type": "is-dark"
    }
  }, [_vm._v("Dark")]), _vm._v(" "), _c('b-button', {
    attrs: {
      "type": "is-text"
    }
  }, [_vm._v("Text")])], 1), _vm._v(" "), _c('div', {
    staticClass: "buttons"
  }, [_c('b-button', {
    attrs: {
      "disabled": ""
    }
  }, [_vm._v("Disabled")]), _vm._v(" "), _c('b-button', {
    attrs: {
      "loading": ""
    }
  }, [_vm._v("Loading")]), _vm._v(" "), _c('b-button', {
    attrs: {
      "rounded": ""
    }
  }, [_vm._v("Rounded")])], 1), _vm._v(" "), _c('div', {
    staticClass: "buttons"
  }, [_c('b-button', {
    attrs: {
      "type": "is-primary",
      "outlined": ""
    }
  }, [_vm._v("Outlined")]), _vm._v(" "), _c('b-button', {
    attrs: {
      "type": "is-success",
      "outlined": ""
    }
  }, [_vm._v("Outlined")]), _vm._v(" "), _c('b-button', {
    attrs: {
      "type": "is-danger",
      "outlined": ""
    }
  }, [_vm._v("Outlined")]), _vm._v(" "), _c('b-button', {
    attrs: {
      "type": "is-warning",
      "outlined": ""
    }
  }, [_vm._v("Outlined")])], 1), _vm._v(" "), _c('div', {
    staticClass: "buttons"
  }, [_c('b-button', {
    attrs: {
      "type": "is-primary",
      "expanded": ""
    }
  }, [_vm._v("Expanded")])], 1), _vm._v(" "), _c('div', {
    staticClass: "notification is-primary"
  }, [_c('b-button', {
    attrs: {
      "type": "is-primary",
      "inverted": ""
    }
  }, [_vm._v("\n                Inverted\n            ")]), _vm._v(" "), _c('b-button', {
    attrs: {
      "type": "is-primary",
      "inverted": "",
      "outlined": ""
    }
  }, [_vm._v("\n                Invert Outlined\n            ")])], 1)])
},staticRenderFns: []}

/***/ }),

/***/ 974:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('div', {
    staticClass: "buttons"
  }, [_c('b-button', {
    attrs: {
      "size": "is-small",
      "icon-left": "github-circle"
    }
  }, [_vm._v("\n                Add\n            ")]), _vm._v(" "), _c('b-button', {
    attrs: {
      "icon-left": "github-circle"
    }
  }, [_vm._v("\n                Add\n            ")]), _vm._v(" "), _c('b-button', {
    attrs: {
      "size": "is-medium",
      "icon-left": "github-circle"
    }
  }, [_vm._v("\n                Add\n            ")]), _vm._v(" "), _c('b-button', {
    attrs: {
      "size": "is-large",
      "icon-left": "github-circle"
    }
  }, [_vm._v("\n                Add\n            ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "buttons"
  }, [_c('b-button', {
    attrs: {
      "type": "is-danger",
      "icon-left": "delete"
    }
  }, [_vm._v("\n                Delete\n            ")]), _vm._v(" "), _c('b-button', {
    attrs: {
      "type": "is-danger",
      "icon-right": "delete"
    }
  }, [_vm._v("\n                Delete\n            ")]), _vm._v(" "), _c('b-button', {
    attrs: {
      "type": "is-danger",
      "icon-right": "delete"
    }
  })], 1)])
},staticRenderFns: []}

/***/ }),

/***/ 975:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('div', {
    staticClass: "buttons"
  }, [_c('b-button', {
    attrs: {
      "size": "is-small"
    }
  }, [_vm._v("Small")]), _vm._v(" "), _c('b-button', [_vm._v("Default")]), _vm._v(" "), _c('b-button', {
    attrs: {
      "size": "is-medium"
    }
  }, [_vm._v("Medium")]), _vm._v(" "), _c('b-button', {
    attrs: {
      "size": "is-large"
    }
  }, [_vm._v("Large")])], 1)])
},staticRenderFns: []}

/***/ }),

/***/ 976:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('div', {
    staticClass: "buttons"
  }, [_c('b-button', [_vm._v("Button")]), _vm._v(" "), _c('b-button', {
    attrs: {
      "tag": "a",
      "href": "https://buefy.org",
      "target": "_blank"
    }
  }, [_vm._v("\n                Anchor\n            ")]), _vm._v(" "), _c('b-button', {
    attrs: {
      "tag": "input",
      "native-type": "submit",
      "value": "Submit input"
    }
  })], 1)])
},staticRenderFns: []}

/***/ }),

/***/ 977:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('div', {
    staticClass: "buttons"
  }, [_c('b-button', {
    attrs: {
      "tag": "router-link",
      "to": "/documentation",
      "type": "is-link"
    }
  }, [_vm._v("\n                Docs\n            ")]), _vm._v(" "), _c('b-button', {
    attrs: {
      "tag": "router-link",
      "to": "/expo",
      "type": "is-info"
    }
  }, [_vm._v("\n                Expo\n            ")])], 1)])
},staticRenderFns: []}

/***/ })

});


// WEBPACK FOOTER //
// static/js/21.aa59e7eb45e11ae9c4f5.js